import { NETWORK_ACTION, NETWORK_PATH } from '../../constants'
import setReduxAction from '../../../redux/actions/set'

function updateIsSendingDataNetworkAction (value) {
  return setReduxAction({
    type: value
      ? NETWORK_ACTION.UPDATE_IS_SENDING_DATA
      : NETWORK_ACTION.RESET_IS_SENDING_DATA,
    payload: {
      path: NETWORK_PATH.IS_SENDING_DATA,
      value
    }
  })
}

export default updateIsSendingDataNetworkAction
